import { operatorDefinitions } from '../operatorDefinitions';
// Given an array of operatorDefinition key names, return an array of operatorDefinition objects
export const mapOperator = (array: string[]): unknown[] => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return array.map((op: string) => operatorDefinitions[op]).filter((o) => o);
};
